import { Button } from '@/components/form/Button';
import { ButtonVariant } from '@/components/form/buttonHelper';
import { useRole } from '@/services/authentication/hooks/user';
import { FC } from 'react';
import { useNavigate } from 'react-router';
import { LandingPageSection } from './LandingPageSection';
import { LandingPageStyle } from './landingPage.types';

export const CustomerLandingPage: FC = () => {
  const role = useRole();
  const navigate = useNavigate();

  const prefix = '';
  const standardiseLink = `${prefix}/financeModels`;
  const stockCalculatorLink = `${prefix}/purchaseOrders`;
  const bundleLink = `${prefix}/bundles`;

  return (
    <>
      <LandingPageSection
        color={LandingPageStyle.ORANGE}
        imageUrl={'https://daasportal.app/wp-content/uploads/2023/06/DaaS-is-Different.webp'}
        title={'Standardise Products'}
        stepNumber={1}
      >
        <p>Pick the products your business intends to use.</p>
        <Button variant={ButtonVariant.Secondary} onClick={() => navigate(standardiseLink)}>
          Go to Standardised Products
        </Button>
      </LandingPageSection>
      <LandingPageSection
        color={LandingPageStyle.BLUE}
        imageUrl={'https://daasportal.app/wp-content/uploads/2023/06/Diverse-Team.webp'}
        title={'Build Bundles'}
        stepNumber={2}
        imageContainerClassName="bg-[-135px]"
      >
        <p>Pick the right products for the right people, to suit your organisation.</p>
        <Button variant={ButtonVariant.Secondary} onClick={() => navigate(bundleLink)}>
          Go to Bundle Builder
        </Button>
      </LandingPageSection>
      <LandingPageSection
        color={LandingPageStyle.ORANGE}
        imageUrl={'https://daasportal.app/wp-content/uploads/2023/06/Van.png'}
        title={'Order'}
        stepNumber={3}
      >
        <p>Order your Products</p>
        <Button variant={ButtonVariant.Secondary} onClick={() => navigate(stockCalculatorLink)}>
          Go to Orders / Quotes
        </Button>
      </LandingPageSection>
    </>
  );
};
